// Non-linear unit conversions implemented in code (doc 05 §1.1). No runtime expression
// evaluation: `seed/units.json` only names one of these functions.

/** Density of water at 60 °F in kg/m³ — the same constant as the `sg` unit factor. */
const WATER_60F_KG_M3 = 999.016;

export const UNIT_FUNCTIONS = {
  // kg/m3 = 141.5 / (API + 131.5) × 999.016
  api_gravity: {
    toBase: (api: number): number => (141.5 / (api + 131.5)) * WATER_60F_KG_M3,
    fromBase: (kgM3: number): number => (141.5 * WATER_60F_KG_M3) / kgM3 - 131.5,
  },
} as const;

export type UnitFunctionName = keyof typeof UNIT_FUNCTIONS;
